const play = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><polygon stroke-linecap="round" stroke-width="1.5" points="5.6 5 11.6 8.375 5.6 11.75"/><rect width="14.5" height="14.5" x=".75" y=".75" stroke-width="1.5" rx="1"/></svg>',
};

export { play as default };
